import React from "react";
import { Users, Plus } from "lucide-react";

const CastingDashboardHeader = ({
  dashboardData,
  setShowFollowersModal,
  navigate
}) => {
  return (
    <div className="cdd-header">
      <div>
        <h1 className="cdd-title">Casting Dashboard</h1>
        <p className="cdd-subtitle">Manage your projects, roles, and review incoming talent.</p>
      </div>

      <div className="cdd-header-right-wrapper">
        <div 
          className="cdd-followers-tile" 
          onClick={() => setShowFollowersModal(true)} 
          title="Click to view followers"
        >
          <div className="cdd-followers-icon-box">
            <Users size={16} color="#3b82f6" />
          </div>
          <div className="cdd-followers-info">
            <span className="cdd-followers-label">Followers</span>
            <span className="cdd-followers-count">
              {dashboardData?.kpis?.followersCount ?? dashboardData?.followers?.length ?? 0} Talents
            </span>
          </div>
        </div>

        <button className="cdd-btn-primary" onClick={() => navigate('/dashboard/post-roles')}>
          <Plus size={18} /> Post New Role
        </button>
      </div>
    </div>
  );
};

export default CastingDashboardHeader;
